import React, { useState, useEffect } from "react";
import Select from "react-select";
import { getRequest } from "../../../../../../utils/httpRequest";

const AdvancedOptions = ({updateParent, getData}) => {
  const [countries, setCountries] = useState([])
  const [visibility, setVisibility] = useState(false)
  const [countryLimitationType, setCountryLimitationType] = useState('none')
  const [timezone, setTimeZone] = useState([{"label":"Pacific\/Midway","value":"(GMT-11:00) Pacific, Midway - 7:11 AM"},{"label":"Pacific\/Niue","value":"(GMT-11:00) Pacific, Niue - 7:11 AM"},{"label":"Pacific\/Pago_Pago","value":"(GMT-11:00) Pacific, Pago Pago - 7:11 AM"},{"label":"Pacific\/Honolulu","value":"(GMT-10:00) Pacific, Honolulu - 8:11 AM"},{"label":"Pacific\/Rarotonga","value":"(GMT-10:00) Pacific, Rarotonga - 8:11 AM"},{"label":"Pacific\/Tahiti","value":"(GMT-10:00) Pacific, Tahiti - 8:11 AM"},{"label":"Pacific\/Marquesas","value":"(GMT-09:30) Pacific, Marquesas - 8:41 AM"},{"label":"America\/Adak","value":"(GMT-09:00) America, Adak - 9:11 AM"},{"label":"Pacific\/Gambier","value":"(GMT-09:00) Pacific, Gambier - 9:11 AM"},{"label":"America\/Anchorage","value":"(GMT-08:00) America, Anchorage - 10:11 AM"},{"label":"America\/Juneau","value":"(GMT-08:00) America, Juneau - 10:11 AM"},{"label":"America\/Metlakatla","value":"(GMT-08:00) America, Metlakatla - 10:11 AM"},{"label":"America\/Nome","value":"(GMT-08:00) America, Nome - 10:11 AM"},{"label":"America\/Sitka","value":"(GMT-08:00) America, Sitka - 10:11 AM"},{"label":"America\/Yakutat","value":"(GMT-08:00) America, Yakutat - 10:11 AM"},{"label":"Pacific\/Pitcairn","value":"(GMT-08:00) Pacific, Pitcairn - 10:11 AM"},{"label":"America\/Creston","value":"(GMT-07:00) America, Creston - 11:11 AM"},{"label":"America\/Dawson","value":"(GMT-07:00) America, Dawson - 6:11 PM"},{"label":"America\/Dawson_Creek","value":"(GMT-07:00) America, Dawson Creek - 11:11 AM"},{"label":"America\/Fort_Nelson","value":"(GMT-07:00) America, Fort Nelson - 11:11 AM"},{"label":"America\/Hermosillo","value":"(GMT-07:00) America, Hermosillo - 11:11 AM"},{"label":"America\/Los_Angeles","value":"(GMT-07:00) America, Los Angeles - 11:11 AM"},{"label":"America\/Phoenix","value":"(GMT-07:00) America, Phoenix - 11:11 AM"},{"label":"America\/Tijuana","value":"(GMT-07:00) America, Tijuana - 11:11 AM"},{"label":"America\/Vancouver","value":"(GMT-07:00) America, Vancouver - 11:11 AM"},{"label":"America\/Whitehorse","value":"(GMT-07:00) America, Whitehorse - 6:11 PM"},{"label":"America\/Belize","value":"(GMT-06:00) America, Belize - 12:11 PM"},{"label":"America\/Boise","value":"(GMT-06:00) America, Boise - 12:11 PM"},{"label":"America\/Cambridge_Bay","value":"(GMT-06:00) America, Cambridge Bay - 12:11 PM"},{"label":"America\/Chihuahua","value":"(GMT-06:00) America, Chihuahua - 12:11 PM"},{"label":"America\/Costa_Rica","value":"(GMT-06:00) America, Costa Rica - 12:11 PM"},{"label":"America\/Denver","value":"(GMT-06:00) America, Denver - 12:11 PM"},{"label":"America\/Edmonton","value":"(GMT-06:00) America, Edmonton - 12:11 PM"},{"label":"America\/El_Salvador","value":"(GMT-06:00) America, El Salvador - 12:11 PM"},{"label":"America\/Guatemala","value":"(GMT-06:00) America, Guatemala - 12:11 PM"},{"label":"America\/Inuvik","value":"(GMT-06:00) America, Inuvik - 12:11 PM"},{"label":"America\/Managua","value":"(GMT-06:00) America, Managua - 12:11 PM"},{"label":"America\/Mazatlan","value":"(GMT-06:00) America, Mazatlan - 12:11 PM"},{"label":"America\/Ojinaga","value":"(GMT-06:00) America, Ojinaga - 12:11 PM"},{"label":"America\/Regina","value":"(GMT-06:00) America, Regina - 12:11 PM"},{"label":"America\/Swift_Current","value":"(GMT-06:00) America, Swift Current - 12:11 PM"},{"label":"America\/Tegucigalpa","value":"(GMT-06:00) America, Tegucigalpa - 12:11 PM"},{"label":"America\/Yellowknife","value":"(GMT-06:00) America, Yellowknife - 12:11 PM"},{"label":"Pacific\/Galapagos","value":"(GMT-06:00) Pacific, Galapagos - 12:11 PM"},{"label":"America\/Atikokan","value":"(GMT-05:00) America, Atikokan - 1:11 PM"},{"label":"America\/Bahia_Banderas","value":"(GMT-05:00) America, Bahia Banderas - 1:11 PM"},{"label":"America\/Bogota","value":"(GMT-05:00) America, Bogota - 1:11 PM"}])
  const [dutyHours, setDutyHours] = useState([
    {day: 'Monday', active: true, startTime: '00:00:00', endTime: '23:59:59'},
    {day: 'Tuesday', active: true, startTime: '00:00:00', endTime: '23:59:59'},
    {day: 'Wednesday', active: true, startTime: '00:00:00', endTime: '23:59:59'},
    {day: 'Thursday', active: true, startTime: '00:00:00', endTime: '23:59:59'},
    {day: 'Friday', active: true, startTime: '00:00:00', endTime: '23:59:59'},
    {day: 'Saturday', active: true, startTime: '00:00:00', endTime: '23:59:59'},
    {day: 'Sunday', active: true, startTime: '00:00:00', endTime: '23:59:59'}
  ])

  const getCountries = () => {
    getRequest("/p2p_trades/countries").then(response => {
      const countriesArray = response.map(country => ({
        label: country.name,
        value: country.code
      }));

      setCountries(countriesArray);
    });
  }

  const dutyHourChecked = (day) => {
    const updatedHour = dutyHours.filter((duty) => duty.day === day);
    return updatedHour.active;
  }

  const onOptionChange = e => {
    setCountryLimitationType(e.target.value);
    updateParent("countryLimitationType", e.target.value);
  }

  const onDutyHoursChange = (isChecked, day) => {
      const updatedHours = dutyHours.filter((duty) => duty.day !== day);
      updatedHours.push({day, active: isChecked, startTime: '00:00:00', endTime: '23:59:59'});
      setDutyHours(updatedHours);
      updateParent("dutyHours", dutyHours);
  }

  useEffect(() => {
    getCountries();
  }, []);

  return (<div className="row">
    <div className="form-group  col-md-12">
      <strong><label htmlFor="exampleInputEmail1">Target Country</label></strong>
      <p>
        Select a specific country you would like to target and additional
        traffic will come from this market.
      </p>
      <Select options={countries} placeholder="select (optional)" className="bg-white" onChange={(e) => { 
        updateParent('selectedCountry', e.value)
        }}/>
    </div>
    <div className="form-group  col-md-12">
        <strong><label htmlFor="exampleInputPassword1">Visibility</label></strong>
        <div className="custom-control custom-checkbox">
          <input type="checkbox" className="custom-control-input" id="trustedUsers" name="visibility" checked={visibility} onChange={(e) =>{
             setVisibility(e.target.checked);
             updateParent('showOnlyTrustedUser', e.target.checked);
            }}/>
          <label className="custom-control-label" htmlFor="trustedUsers">Show this offer only to my list of trusted users</label>
        </div>
        <div className="custom-control custom-checkbox">
          <input type="checkbox" className="custom-control-input" id="buyersLocalCurrency" name="example1" />
          <label className="custom-control-label" htmlFor="buyersLocalCurrency">The buyer’s local currency should match my offer’s currency</label>
        </div>
    </div>

    <div className="form-group col-md-12">
   
        <strong><label htmlFor="exampleInputEmail1">Minimum Trades Required</label></strong>
          <p>Show my offer only to users who have completed at least:</p>

        <input
          type="text"
          className="form-control bg-white"
          id="exampleInputPassword1"
          placeholder="Type minimum trades count..."
          onChange={(e) => updateParent('requireMinPastTrades', e.target.value)}
        />

        <div>past trades</div>
    </div>


    <div className="form-group col-md-12">
    <strong><label htmlFor="exampleInputEmail1">Limit for New Users</label></strong>
      <p>New users can only trade up to:</p>
      <div className="input-group mb-2 mr-sm-2">
        <input
          type="text"
          className="form-control bg-white"
          id="inlineFormInputGroupUsername2"
          placeholder="Enter limit for new users ..."
        />
        <div className="input-group-prepend">
          <div className="input-group-text">{getData('selectedCurrency')?.value}</div>
        </div>
      </div>
    </div>

    <div className="form-group col-md-12">
    <strong><label htmlFor="exampleInputEmail1"> Limitation by Countries</label></strong>
      <div className="custom-control custom-radio">
        <input type="radio" className="custom-control-input" id="limitNone" name="limitByCountry" value="none" 
          checked={countryLimitationType === "none"}
          onChange={onOptionChange}
        />
        <label className="custom-control-label" htmlFor="limitNone">None</label>
      </div>              

      <div className="custom-control custom-radio">
        <input type="radio" className="custom-control-input" id="blockedCountries" name="limitByCountry" value="blocked_countries"           
          checked={countryLimitationType === "blocked_countries"}
          onChange={onOptionChange}
        />
        <label className="custom-control-label" htmlFor="blockedCountries">Blocked countries</label>
      </div>

      <div className="custom-control custom-radio">
        <input type="radio" className="custom-control-input" id="allowedCountries" name="limitByCountry" value="allowed_countries" 
          checked={countryLimitationType === "allowed_countries"}
          onChange={onOptionChange}
        />
        <label className="custom-control-label" htmlFor="allowedCountries">Allowed countries</label>
      </div>

      <Select options={countries} placeholder="Select or type manually" isMulti={true} className="bg-white" onChange={(items) => updateParent('countryLimitationList', items)}/>
    </div>

    

    <div className="form-group col-md-12">
    <strong><label htmlFor="exampleInputEmail1">Proxy/VPN Users</label></strong>
      <div className="custom-control custom-radio">
        <input type="radio" className="custom-control-input" id="proxyNone" checked name="example1" value="customEx" />
        <label className="custom-control-label" htmlFor="proxyNone">None</label>
      </div>
      <div className="custom-control custom-radio">
        <input type="radio" className="custom-control-input" id="dontAllowVpn" name="example1" value="customEx" />
        <label className="custom-control-label" htmlFor="dontAllowVpn">Don’t allow VPN, or any other anonymous users</label>
      </div>
 
    </div>
    <div className="form-group col-md-12">
    <strong><label htmlFor="exampleInputEmail1">Working Hours</label></strong><br/>
      <label>
        Choose the days of the week and times during each day when you want this
        offer to be active.
      </label>
      <div className="form-group  col-md-12">
        <div className="custom-control custom-checkbox">
          <input type="checkbox" className="custom-control-input" id="MondayCheck" name="days" checked={dutyHourChecked('Monday')} onChange={(e) =>{
             onDutyHoursChange(e.target.checked, 'Monday');
            }
             }/>
          <label className="custom-control-label" for="MondayCheck">Monday</label>
        </div>
        <div className="custom-control custom-checkbox">
          <input type="checkbox" className="custom-control-input" id="TuesdayCheck" name="days" checked={dutyHourChecked('Tuesday')} onChange={(e) =>{
             onDutyHoursChange(e.target.checked, 'Tuesday');
            }
             }/>
          <label className="custom-control-label" for="TuesdayCheck">Tuesday</label>
        </div>
        <div className="custom-control custom-checkbox">
          <input type="checkbox" className="custom-control-input" id="WednesdayCheck" name="days" checked={dutyHourChecked('Wednesday')} onChange={(e) =>{
             onDutyHoursChange(e.target.checked, 'Wednesday');
            }
             }/>
          <label className="custom-control-label" for="WednesdayCheck">Wednesday</label>
        </div>
        <div className="custom-control custom-checkbox">
          <input type="checkbox" className="custom-control-input" id="ThursdayCheck" name="days" checked={dutyHourChecked('Thursday')} onChange={(e) =>{
             onDutyHoursChange(e.target.checked, 'Thursday');
            }
             }/>
          <label className="custom-control-label" for="ThursdayCheck">Thursday</label>
        </div>
        <div className="custom-control custom-checkbox">
          <input type="checkbox" className="custom-control-input" id="FridayCheck" name="days" checked={dutyHourChecked('Friday')} onChange={(e) =>{
             onDutyHoursChange(e.target.checked, 'Friday');
            }
             }/>
          <label className="custom-control-label" for="FridayCheck">Friday</label>
        </div>
        <div className="custom-control custom-checkbox">
          <input type="checkbox" className="custom-control-input" id="SaturdayCheck" name="days" checked={dutyHourChecked('Saturday')} onChange={(e) =>{
             onDutyHoursChange(e.target.checked, 'Saturday');
            }
             }/>
          <label className="custom-control-label" for="SaturdayCheck">Saturday</label>
        </div>
        <div className="custom-control custom-checkbox">
          <input type="checkbox" className="custom-control-input" id="SundayCheck" name="days" checked={dutyHourChecked('Sunday')} onChange={(e) =>{
             onDutyHoursChange(e.target.checked, 'Sunday');
            }
             }/>
          <label className="custom-control-label" for="SundayCheck">Sunday</label>
        </div>
      
    </div>
      <strong><label htmlFor="exampleInputEmail1">Your Time Zone</label></strong>
      <Select options={timezone} placeholder="Search for your timezone" menuPosition="fixed"/>
    </div>

  </div>);
};

export default AdvancedOptions;
